import { SalaryNotice } from "model/Salary";

export const SALARY_ADJUSTMENT_ROW_KEY = 3000;

export function getSalaryAdjustment(salary: SalaryNotice): number {
  return (
    salary.additionalRows?.find(
      (additionalRow) =>
        additionalRow?.key === SALARY_ADJUSTMENT_ROW_KEY ||
        additionalRow?.rowConfig?.key === SALARY_ADJUSTMENT_ROW_KEY,
    )?.value ?? 0
  );
}

export function parseSalaryAdjustment(value: string): number | undefined {
  if (value.trim() === "") return 0;

  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : undefined;
}
